export const ADD_UNIT_NO = 'ADD_UNIT_NO'
export const ADD_UNIT_NO_FAILED = 'ADD_UNIT_NO_FAILED'
export const ADD_UNIT_NO_SUCCEEDED = 'ADD_UNIT_NO_SUCCEEDED'
export const CLEAR_CREATED_UNIT_NO = 'CLEAR_CREATED_UNIT_NO'

export const DELETE_UNIT_NO = 'DELETE_UNIT_NO'
export const DELETE_UNIT_NO_FAILED = 'DELETE_UNIT_NO_FAILED'
export const DELETE_UNIT_NO_SUCCEEDED = 'DELETE_UNIT_NO_SUCCEEDED'

export const GET_UNIT_NUMBERS = 'GET_UNIT_NUMBERS'
export const GET_UNIT_NUMBERS_FAILED = 'GET_UNIT_NUMBERS_FAILED'
export const GET_UNIT_NUMBERS_SUCCEEDED = 'GET_UNIT_NUMBERS_SUCCEEDED'
